import { render } from "./ordersTable.vue?vue&type=template&id=08ce0455"
import script from "./ordersTable.vue?vue&type=script&lang=js"
export * from "./ordersTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__